<h1 mat-dialog-title>PDF-regenerering</h1>

<mat-dialog-content class="job-dialog">
  <div *ngIf="jobGroups.length === 0" class="empty-state">
    Ingen PDF-regenereringsjobber funnet.
  </div>

  <div *ngIf="jobGroups.length > 0">
    <mat-form-field appearance="fill" class="job-selector">
      <mat-label>Jobb</mat-label>
      <mat-select
        [(ngModel)]="selectedJobGroupId"
        (selectionChange)="selectJobGroup($event.value)"
      >
        <mat-option *ngFor="let jobGroup of jobGroups" [value]="jobGroup.id">
          {{ groupLabel(jobGroup) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="summary" *ngIf="selectedJobGroup">
      <div>
        <strong>Status:</strong>
        {{ displayJobGroupStatus() }}
      </div>
      <div>
        <strong>Fremdrift:</strong>
        {{ displayJobGroupProgress() }}%
      </div>
      <div>
        <strong>Opprettet:</strong>
        {{ timestamp(selectedJobGroup.createdAt) }}
      </div>
      <div *ngIf="selectedJobGroup.completedAt">
        <strong>Ferdig:</strong>
        {{ timestamp(selectedJobGroup.completedAt) }}
      </div>
      <div *ngIf="selectedJobGroup.user?.name">
        <strong>Startet av:</strong>
        {{ selectedJobGroup.user.name }}
      </div>
      <div *ngIf="selectedJobGroup.payloadsCleanedAt">
        <strong>Antall PDF-er:</strong>
        {{ selectedJobGroup.totalCount || 0 }}
        <span *ngIf="selectedJobGroup.succeededCount !== undefined">
          ({{ selectedJobGroup.succeededCount }} OK<span *ngIf="(selectedJobGroup.failedCount || 0) > 0">, <span style="color: #b71c1c;">{{ selectedJobGroup.failedCount }} feilet</span></span>)
        </span>
      </div>
    </div>

    <mat-progress-bar
      *ngIf="selectedJobGroup && !selectedJobGroup.payloadsCleanedAt"
      mode="determinate"
      [value]="displayJobGroupProgress()"
    ></mat-progress-bar>

    <div class="job-table" *ngIf="!selectedJobGroup?.payloadsCleanedAt && jobs.length > 0">
      <div class="job-row job-header">
        <div>Jobb</div>
        <div>Status</div>
        <div>Fremdrift</div>
        <div>Sist oppdatert</div>
      </div>
      <div class="job-row" *ngFor="let job of jobs">
        <div>
          <div>{{ job.jobIdentifier || job.id }}</div>
          <div class="job-path">{{ job.filepath }}</div>
        </div>
        <div>{{ displayJobStatus(job) }}</div>
        <div>{{ displayJobProgress(job) }}%</div>
        <div>{{ timestamp(job.state?.timestamp) }}</div>
        <div class="job-error" *ngIf="job.state?.errorMessage">
          {{ job.state.errorMessage }}
        </div>
      </div>
    </div>

    <div class="failure-summary" *ngIf="selectedJobGroup?.payloadsCleanedAt && (selectedJobGroup?.failures?.length || 0) > 0">
      <h3 style="margin-top: 16px;">Feil ({{ selectedJobGroup.failures.length }})</h3>
      <div class="job-table">
        <div class="job-row job-header">
          <div>Sjekkliste</div>
          <div>Objekt</div>
          <div>Feilmelding</div>
        </div>
        <div class="job-row" *ngFor="let failure of selectedJobGroup.failures">
          <div>{{ failure.checklistId || '-' }}</div>
          <div>{{ failure.objectId || '-' }}</div>
          <div class="job-error">{{ failure.errorMessage || '-' }}</div>
        </div>
      </div>
    </div>

    <div *ngIf="selectedJobGroup?.payloadsCleanedAt && (selectedJobGroup?.failures?.length || 0) === 0" style="margin-top: 16px; color: #2e7d32;">
      Alle PDF-er ble regenerert uten feil.
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    color="warn"
    *ngIf="data.user?.superAdmin && selectedJobGroup"
    [disabled]="isDeleting"
    (click)="deleteSelectedJobGroup()"
  >
    Slett jobb
  </button>
  <button mat-button mat-dialog-close>Lukk</button>
</mat-dialog-actions>
